import React, { useEffect, useState } from 'react';
import { useForm } from '../../../../shared/hooks/form-hook';
// import { useHttpClient } from '../../../../shared/hooks/http-hook';
import Input from '../../../../shared/components/FormElements/input';
import ImageUpload from '../../../../shared/components/FormElements/imageUpload';
import { VALIDATOR_REQUIRE } from '../../../../shared/util/validators';
import { Button } from '@mui/material';
import { NavLink, useHistory, useParams } from 'react-router-dom/cjs/react-router-dom.min';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';


import './updateMend.css';




const UpdateMend = () => {
    const { mendId }  = useParams();
    const history = useHistory();
   
    const [isLoading, setIsLoading] = useState(false)
    const [isLoaded, setIsLoaded] = useState();

    const [formState, inputHandler, setFormData] = useForm( 
        {
            name: {
                value:'',
                isValid: false
            },
            title: {
                value: '',
                isValid: false
            }, 
            image: {
                value: null,
                isValid: false
            },
            article: {
                value:'',
                isValid: false
            }
       },
false
    
);
 

useEffect(() => {
    const fetchMend = async () => {
        setIsLoading(true)
        try{
          const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/mend/${mendId}`);
          const responseData = await response.json();
          setIsLoaded(responseData.mend);

          setFormData(
            {
                name:{
                    value: responseData.mend.name,
                    isValid: true
                },
                title: {
                    value: responseData.mend.title,
                    isValid: true
                }, 
                image: {
                    value: responseData.mend.image ,
                    isValid: true
                },
                article: {
                    value: responseData.mend.article ,
                    isValid: true
                }
            },
            true
        ); 
        } catch (err) {
            console.log(err.message)
        }
      
    }
   
    fetchMend();
}, [ mendId, setFormData])

   

    const submitHandler = async (event) => {
        event.preventDefault();

        try {
            const formData = new FormData();
            formData.append('name', formState.inputs.name.value);
            formData.append('title', formState.inputs.title.value);
            formData.append('article', formState.inputs.article.value);

            // Append image if a new one is uploaded
            if (formState.inputs.image.value instanceof File){
                formData.append('image', formState.inputs.image.value);
            }


             await fetch(`${process.env.REACT_APP_BACKEND_URL}/mend/${mendId}`, {
                method: 'PATCH',
                body: formData,
                // headers: {
                //     'Content-Type': 'application/json'
                // }
            });

        } catch (err) {
            console.log(err.message)
        }

           
        
        // console.log(formState.inputs) // sending to backend
        history.push('/')
    }

    

    if(!isLoading){
        return<div> <h2>Loading...</h2> </div>
        

           
    }

    if(!isLoaded){
        return <div>Article not found!</div>
    }
return(

        <main className='update-form'>

            <NavLink to='/'><FontAwesomeIcon icon={faArrowLeft} className='font-controller-announce'/></NavLink>
            
            <h1>This is Edit page</h1>         
            <div className='update-form-container'>

           { isLoaded &&  (
            <form onSubmit={submitHandler} className='form-controllor'>
                <Input 
                    id='name'
                    element='input'
                    type='text'
                    label='Name'
                    autoComplete='off' 
                    errorText='Please enter a valid title'
                    validators={[VALIDATOR_REQUIRE()]}  
                    onInput={inputHandler}
                    initialValue={isLoaded.name}
                />
            
                <Input 
                    id='title'
                    element='input'
                    type='text'
                    label='Title'
                    autoComplete='off' 
                    validators={[VALIDATOR_REQUIRE()]} 
                    errorText='Please enter a valid title'
                    onInput={inputHandler}
                    initialValue={isLoaded.title}
                />
                <ImageUpload 
                  id='image'      
                  onInput={inputHandler}
                  initialValue={isLoaded.image}
                />

                <Input 
                    id='article'
                    element='textarea'
                    type='text'
                    label='article'
                    autoComplete='off' 
                    errorText='Field is empty'
                    validators={[VALIDATOR_REQUIRE()]}  
                    onInput={inputHandler}
                    initialValue={isLoaded.article}
                />
                <Button type='submit' variant='contained' style={{marginTop: '20px'}}>Update</Button>
            </form>
             )} 
            </div>
        </main>
    )
}

export default UpdateMend;